module.exports = __webpack_public_path__ + "media/components/homepage/static/birds-30cd93d584397a5e54336f0a56c65da4.jpg";